import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.PrePostJobCheck = {
  onLeftNavButtonClick: function (onStepRetreat) {
    onStepRetreat(JobWizard.Details)
  },

  buttonLayout: function () {
    return 'exitButton'
  },

  component: React.createClass({
    getInitialState() {
      return { 
        duplicateJobId: 0,
        errorMessage: "",
        loading: true
      }
    },

    componentDidMount() {
      $('.modal-footer').addHidden()
      this.checkJob()
    },

    buildError() {
      // we want to decide which error to display
      if (this.state.dailyJobContExceeded) { return "TOO_MANY_JOB_REQUESTS" }
      if (this.state.duplicateJobExits) { return "DUPLICATE_JOB" }

      return "";
    },

    checkJob() {
      var self = this
      var job = Job.Data

      var jobDetails = SS.API.V3.prePostJobCheck({
        suburbId: job.suburb_id,
        subCategoryId: job.category_id
      })

      $.ajax(jobDetails)
        .done(function (data) {
          self.setState({ duplicateJobId: data.meta.duplicate_job_id })
          self.setState({ duplicateJobExits: data.meta.duplicate_job_exists })
          self.setState({ dailyJobContExceeded: data.meta.daily_job_count_exceeded })
          self.setState({ dailyJobCount: data.meta.daily_job_count })
          self.setState({ errorMessage: self.buildError() })

          $('.modal-footer').rmHidden()

          if (self.state.errorMessage === "") {
            JobWizard.Emitter.emit('job:wizard:advanceToNextStep')
          }
          else
          {
            self.setState({ loading: false })
          }
        })
        .fail(function () {
          $('.modal-footer').rmHidden()
          // do not block jobs, redirect on any failure
          JobWizard.Emitter.emit('job:wizard:advanceToNextStep')
        })
    },

    duplicateJob() {
      return (
        <div>
          <h3>It looks like you already posted a job for {Job.Data.category} in {Job.Data.suburb}</h3>
          <br />
          <div><a href={`/jobs/${this.state.duplicateJobId}`}>See your existing job</a></div>
          <br />
          <p>Got a problem and need help? Check out our <a href="#{I18n.t(:'ss.help_centre.faq_url')}">FAQs</a></p>
        </div>
      )
    },

    overLimit() {
      return (
        <div>
          <h3>You've posted the maximum allowable jobs for today. Please try again tomorrow.</h3>
          <br />
          <p>Got a problem and need help? Check out our <a href="#{I18n.t(:'ss.help_centre.faq_url')}">FAQs</a></p>
        </div>
      )
    },

    loading() {
      return (
        <div className="modal-body job-form-body radius-16-bottom">
          <h3>Processing...
                <div className="spinner-icon text-center" style={{ marginLeft: '15px' }} />
          </h3>
        </div>
      )
    },

    render: function () {
      return (
        <div>
          {this.state.loading && this.loading()}
          {!this.state.loading && this.state.errorMessage === "TOO_MANY_JOB_REQUESTS" && this.overLimit()}
          {!this.state.loading && this.state.errorMessage === "DUPLICATE_JOB" && this.duplicateJob()}
        </div>
      )
    }
  })
}
